<template>
  <b-form-select v-model="selected" :options="options" @change="$emit('input', selected)"></b-form-select>
</template>

<script>
export default {
  props: ['isDisabled'],

  data() {
    return {
      selected: null,
      options: [
        { value: null, text: this.$i18n.t('Todos') },
        { value: true, text: this.$i18n.t('Sim') },
        { value: false, text: this.$i18n.t('Não') }
      ]
    };
  }
};
</script>
